import toDateTime from "./toDateTime";

export default v => toDateTime(new Date(v));
